export enum DialogReturnType {
    SUBMIT = "SUBMIT",
    CANCEL = "CANCEL",
    SECONDARY = "SECONDARY"
}